import { render, staticRenderFns } from "./IconToastExclamation.vue?vue&type=template&id=c0fd0752&scoped=true&functional=true"
import script from "./IconToastExclamation.vue?vue&type=script&lang=js"
export * from "./IconToastExclamation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "c0fd0752",
  null
  
)

export default component.exports